(function () {
  // Add custom code below this line

  // Check if device has touch capability
  if (window.theme.touch) {
    // Wait for DOM to be fully loaded
    // For native HTML5 videos
    const productItemVideos = document.querySelectorAll('.product-item__bg__under video');

    if (productItemVideos.length > 0) {
      productItemVideos.forEach((video) => {
        // disable autoplay and pause
        video.autoplay = false;
        video.setAttribute('playsinline', 'false');
        video.setAttribute('preload', 'none');
        video.pause();
      });
    }
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
